<template>
  <v-app class="main-container-max-height">
    <PerfectScrollbar
      ref="refChatGptPS"
      :options="perfectScrollbarOptions"
      class="mv-h-full"
    >
      <div class="text-center mt-10" v-show="isLoadingData">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-container fluid>
        <MvWdCanvasList v-show="!isLoadingData" :canvasList="canvasList" />
      </v-container>
    </PerfectScrollbar>
  </v-app>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
//例如: import <组件名称> from  <组建路径>
import MvWdCanvasList from "./widgets/mv-wd-canvas-list.vue";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    PerfectScrollbar,
    MvWdCanvasList,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      // Perfect scrollbar options
      perfectScrollbarOptions: {
        maxScrollbarLength: 100,
        wheelPropagation: false,
      },
      isLoadingData: true,
      canvasList: [],
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {},
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    let that = this;
    window.setTimeout(function () {
      that.isLoadingData = false;
      that.canvasList.push({
        id: "a1b9ad909999",
        cover: "https://bocorp-dev.yipinapp.com/gds/images/cover.png",
        createdTime: "2023-4-26 17:00",
      });
      // that.canvasList.push({
      //   id: "a1b9ad909999",
      //   cover: "https://bocorp-dev.yipinapp.com/gds/images/cover.png",
      //   createdTime: "2023-4-26 18:00",
      // });
    }, 1000);
  },
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style scoped></style>
